module.exports = __webpack_public_path__ + "media/images/app/products/index/styles/bracelets/tennis-18d353a6a2ebf45c9744f183ea753203.webp";